// extracted by mini-css-extract-plugin
module.exports = {"root":"CookiePolicy_root__3kBN6","section":"CookiePolicy_section__19q2O","table":"CookiePolicy_table__1q3T4"};